<template>
  <main class="main">
    <section class="banner banner--form">
      <div class="container">
        <div class="banner--copy">
          <h2> {{ $route.name }} </h2>
          <p>{{ $route.name }}</p>
        </div>
      </div>
      <div class="mask"></div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'CookiePolicy'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/cookiePolicy.vue